import React, { createContext, useContext, useState, useCallback } from 'react';
import { ToastMessage } from '../components/Toast/ToastContainer';
import ToastContainer from '../components/Toast/ToastContainer';

interface NotificationContextType {
  showNotification: (message: string, type: ToastMessage['type']) => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(
  undefined,
);

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      'useNotification must be used within a NotificationProvider',
    );
  }
  return context;
};

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const showNotification = useCallback(
    (message: string, type: ToastMessage['type']) => {
      const id = Math.random().toString(36).substr(2, 9);
      setToasts((prevToasts) => [...prevToasts, { id, message, type }]);
    },
    [],
  );

  const handleCloseToast = useCallback((id: string) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  }, []);

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <ToastContainer toasts={toasts} onClose={handleCloseToast} />
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
